import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { useBotConversation } from '../../shared/BotConversationContext';

export const ChatFooter = ({ children }: PropsWithChildren) => {
  const { isEmbeddedInHelpCenter } = useBotConversation();

  return (
    <div className={clsx('sgwt-chatbot-footer card-footer w-100 p-0', { 'position-absolute': isEmbeddedInHelpCenter })} style={{ bottom: 0 }}>
      <div className={clsx('footer-background bg-lvl1 bg-blur-fadeout w-100 h-100', { 'position-absolute': isEmbeddedInHelpCenter })} />
      <div className="m-4" style={{ zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};
